import clsx from 'clsx';
import React, { forwardRef, PropsWithChildren } from 'react';
import { Icon, IconProps } from '../icon';
import { Tooltip } from '../tooltip';
import classes from './hint.module.scss';

export type HintProps = PropsWithChildren & Partial<IconProps> & {
  /**
   * The class name of the hint
   */
  className?: string;
};

/**
 * Hint is a React functional component built with forwardRef. It renders
 * a tooltip containing additional content alongside an icon. The icon
 * is displayed with a question-circle design.
 *
 * This component utilizes `Tooltip` for displaying the provided content
 * when users hover over or interact with the icon. It allows for
 * customization of class names and other properties via props.
 */
export const Hint = forwardRef<SVGSVGElement, HintProps>(
  ({ children, className, ...props }, ref) => {
    return (
      <Tooltip as={'span'} content={children} className={clsx(className, classes.root)}>
        <Icon
          tabIndex={-1}
          className={classes.icon}
          ref={ref}
          icon={['far', 'question-circle']}
          {...props}
        />
      </Tooltip>
    );
  }
);
